import { c as _c } from "react/compiler-runtime";
import { cancellationPlan, CancellationPlanType } from "@website/accommodation-ui/villa-reserve-cancellation-policies";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FC } from "react";
export const TabPanel: FC<{
  cancellationPlanType: CancellationPlanType;
  cancellationRules: string;
}> = t0 => {
  const $ = _c(15);
  const {
    cancellationPlanType,
    cancellationRules
  } = t0;
  const cancellationPlanTypeTitle = cancellationPlan[cancellationPlanType];
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== cancellationPlanTypeTitle || $[1] !== cancellationRules) {
    const replacedRules = replaceSnappTripBasedOnChannel(cancellationRules).replaceAll(".", ".\n")?.split("\n");
    t3 = "flex flex-col gap-4";
    if ($[6] !== cancellationPlanTypeTitle) {
      t4 = cancellationPlanTypeTitle ? <p className="text-on-surface-high-emphasis pt-2 font-bold"><span>قوانین این اقامتگاه </span><span className="text-secondary">{cancellationPlanTypeTitle} </span><span>است</span></p> : null;
      $[6] = cancellationPlanTypeTitle;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t1 = "text-sm";
    t2 = replacedRules?.map(_temp);
    $[0] = cancellationPlanTypeTitle;
    $[1] = cancellationRules;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(p, index) {
  return <div key={`${p}-${index}`}>{p}</div>;
}